import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { ViewCell } from 'ng2-smart-table';
import Viewer from 'viewerjs';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageModalComponent implements OnInit, ViewCell, OnDestroy {
  @ViewChild('dialog') dialog!: TemplateRef<any>;
  @ViewChild('image') image!: ElementRef;
  imageIsResolved = false;

  @Input() set value(data: any) {
    this.data = data;
  }

  @Input() rowData: any;
  data: any;
  viewImage = false;
  viewer!: Viewer;

  constructor(private dialogService: NbDialogService) {}

  showImages(): void {
    this.viewImage = true;
    if (this.imageIsResolved) {
      setTimeout(() => {
        this.openImageModal();
      });
    }
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.viewer?.destroy();
  }

  openImageModal() {
    this.viewer = new Viewer(this.image.nativeElement, {
      inline: false,
      zoomRatio: 0.3,
      toolbar: {
        zoomIn: true,
        zoomOut: true,
        oneToOne: true,
        reset: false,
        prev: false,
        play: false,
        next: false,
        rotateLeft: true,
        rotateRight: true,
        flipHorizontal: true,
        flipVertical: true
      }
    });
    this.image.nativeElement.click();
  }

  imageResolved() {
    this.imageIsResolved = true;
    this.openImageModal();
  }
}
